// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__1s89M","main":"Home_main__16Znb","nobuddy":"Home_nobuddy__2VaYg"};